import { ModelStatus } from '../constants/Code';
import * as BoardAction from './BoardAction';
import { showPlatform } from './PostShowPlatform';
import { generateQuery } from '../../utils/miscUtils';

export function PostListStateToProps(state, ownProps) {
  return {
    action: state.BoardReducer.action,
    message: state.BoardReducer.message,
    isLike: state.BoardReducer.action === 'successPostLike',
    isUnLike: state.BoardReducer.action === 'successPostUnlike',
    isPublic:
      state.BoardReducer.action ===
      `successPostStatus:${ModelStatus.ForcePublic}`,
    isPrivate:
      state.BoardReducer.action === `successPostStatus:${ModelStatus.Normal}`,
  };
}

export function PostListDispatchToProps(dispatch, ownProps) {
  const { detailPage, writePage, listPage } = ownProps;
  const query = { ...ownProps.history.query };
  return {
    goPostDetail: (postId, customQuery = {}) => {
      let newQuery = {
        ...query,
      };
      delete newQuery.postid;
      ownProps.history.push(
        `${detailPage}/${postId}${generateQuery(newQuery)}`
      );
    },
    goPostCreate: () => {
      let newQuery = {
        ...query,
      };
      ownProps.history.push(`${writePage}${generateQuery(newQuery)}`);
    },
    goPostList: (pageQuery) => {
      let newQuery = {};
      if (pageQuery) {
        newQuery = { ...pageQuery };
      }
      newQuery = showPlatform(ownProps, newQuery);
      ownProps.history.push(`${listPage}${generateQuery(newQuery)}`);
    },

    completedAction: () => {
      dispatch(BoardAction.completedAction());
    },
    likePost: (postId) => {
      dispatch(BoardAction.likePost(postId));
    },
    unlikePost: (postId) => {
      dispatch(BoardAction.unlikePost(postId));
    },
    postSetStatus: (postId, status) => {
      dispatch(BoardAction.postSetStatus(postId, status));
    },
  };
}
